@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.notification.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.notification.generated.resources/"

internal val Res.string.feature_notification_error_oops: StringResource by lazy {
      StringResource("string:feature_notification_error_oops", "feature_notification_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 47),
      ))
    }

internal val Res.string.feature_notification_loading: StringResource by lazy {
      StringResource("string:feature_notification_loading", "feature_notification_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58, 48),
      ))
    }

internal val Res.string.feature_notification_nothing_to_notify: StringResource by lazy {
      StringResource("string:feature_notification_nothing_to_notify", "feature_notification_nothing_to_notify", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 70),
      ))
    }

internal val Res.string.feature_notification_notifications: StringResource by lazy {
      StringResource("string:feature_notification_notifications", "feature_notification_notifications", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 62),
      ))
    }

internal val Res.string.feature_notification_there_is_nothing_to_show: StringResource by lazy {
      StringResource("string:feature_notification_there_is_nothing_to_show", "feature_notification_there_is_nothing_to_show", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 85),
      ))
    }

internal val Res.string.feature_notification_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_notification_unexpected_error_subtitle", "feature_notification_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327, 118),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_notification_error_oops", Res.string.feature_notification_error_oops)
  map.put("feature_notification_loading", Res.string.feature_notification_loading)
  map.put("feature_notification_nothing_to_notify", Res.string.feature_notification_nothing_to_notify)
  map.put("feature_notification_notifications", Res.string.feature_notification_notifications)
  map.put("feature_notification_there_is_nothing_to_show", Res.string.feature_notification_there_is_nothing_to_show)
  map.put("feature_notification_unexpected_error_subtitle", Res.string.feature_notification_unexpected_error_subtitle)
}
